<template lang="pug">
  .h-full.overflow-scroll.scrolling-touch(class="lg:py-0 lg:absolute lg:inset-0")
    .fixed.z-20.inset-x-0.top-0.my-6.text-center
      a.cursor-pointer(@click="$emit('status')")
        v-fa.text-2xl(icon="arrow-up")
    .min-h-full.flex.flex-col.justify-center.py-24
      .w-full
        share-image
      .mt-12
        misson
</template>
<script>
import ShareImage from "@/components/status/shareImage";
import Misson from "@/components/status/misson";
export default {
  components: {
    ShareImage,
    Misson
  }
};
</script>
